module.exports = __webpack_public_path__ + "img/conical_t1_washer.prt.5c25cca7.jpg";